export enum CustomerDispatchMessageStatus {
  scheduled = "scheduled",
  dispatched = "dispatched",
  error = "error",
}

export namespace CustomerDispatchMessageStatus {
  export const translateType = (type: CustomerDispatchMessageStatus): string => {
    switch (type) {
      case CustomerDispatchMessageStatus.scheduled:
        return "Agendado";
      case CustomerDispatchMessageStatus.dispatched:
        return "Enviado";
      case CustomerDispatchMessageStatus.error:
        return "Falha";
      default:
        return "";
    }
  };

  export const customerDispatchMessageStatusChoices = Object.values(CustomerDispatchMessageStatus).filter(x => typeof x === "string")
  .map(type => {
    return ({
      id: type,
      name: CustomerDispatchMessageStatus.translateType(type as any)
    })
  });
}
